module.exports = __webpack_public_path__ + "img/logo.a86667ea.png";